import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Logo } from './Logo';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Logo size="medium" showText={true} />

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              الرئيسية
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              من نحن
            </button>
            <button
              onClick={() => scrollToSection('brands')}
              className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              أنواع السيارات
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              اتصل بنا
            </button>
          </nav>

          {/* Contact Button */}
          <div className="hidden md:block">
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-blue-900 hover:bg-blue-800 text-white transition-colors"
            >
              <Phone className="ml-2 h-4 w-4" />
              اتصل بنا الآن
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-3">
            <button
              onClick={() => scrollToSection('home')}
              className="text-right py-2 text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              الرئيسية
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-right py-2 text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              من نحن
            </button>
            <button
              onClick={() => scrollToSection('brands')}
              className="text-right py-2 text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              أنواع السيارات
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-right py-2 text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              اتصل بنا
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-blue-900 hover:bg-blue-800 text-white w-full"
            >
              <Phone className="ml-2 h-4 w-4" />
              اتصل بنا الآن
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};